// Field config for the FilterableList on the /policies List tab. Describes what each filter is;
// FilterableList owns layout (4/2/1), the summary line, Clear gating, and the emitted query.

const STATUSES = [
    { code: 'abandoned', labelId: 'Policies_List.search.status.abandoned' },
    { code: 'accepted', labelId: 'Policies_List.search.status.accepted' },
    { code: 'bindRequested', labelId: 'Policies_List.search.status.bindRequested' },
    { code: 'bound', labelId: 'Policies_List.search.status.bound' },
    { code: 'cancelled', labelId: 'Policies_List.search.status.cancelled' },
    { code: 'incomplete', labelId: 'Policies_List.search.status.incomplete' },
    { code: 'issued', labelId: 'Policies_List.search.status.issued' },
    { code: 'lost', labelId: 'Policies_List.search.status.lost' },
    { code: 'quoted', labelId: 'Policies_List.search.status.quoted' },
    { code: 'quoteAccepted', labelId: 'Policies_List.search.status.quoteAccepted' },
    { code: 'quoteIssued', labelId: 'Policies_List.search.status.quoteIssued' },
    { code: 'referred', labelId: 'Policies_List.search.status.referred' },
    { code: 'rejected', labelId: 'Policies_List.search.status.rejected' },
    { code: 'submitted', labelId: 'Policies_List.search.status.submitted' },
];

const TRANSACTION_TYPES = [
    { code: 'new', labelId: 'Policies_List.search.transactionType.newBusiness' },
    { code: 'endorsement', labelId: 'Policies_List.search.transactionType.endorsement' },
    { code: 'cancellation', labelId: 'Policies_List.search.transactionType.cancellation' },
    { code: 'certificate', labelId: 'Policies_List.search.transactionType.certificate' },
];

// Sort-bar columns for ColumnSortBar. One span per column (set on xs, inherited to lg) so the
// header stays aligned with PolicyListItem's rows at every breakpoint - the list is one wide table
// that scrolls horizontally rather than collapsing per screen. Spans sum to 12. `category` picks
// the icon (alpha = A-Z, date = directional); `columnName` is the sort key.
export const LIST_COLUMNS = [
    { labelId: 'Policies_List.table.referenceNumber', xs: 1 },
    {
        labelId: 'Policies_List.table.policyNumber',
        columnName: 'policyNumber',
        sortable: true,
        category: 'alpha',
        xs: 1.5,
    },
    { labelId: 'Policies_List.table.insuredName', columnName: 'insuredName', sortable: true, category: 'alpha', xs: 2 },
    { labelId: 'Policies_List.table.product', xs: 1.5 },
    {
        labelId: 'Policies_List.table.creationDate',
        columnName: 'creationDate',
        sortable: true,
        category: 'date',
        xs: 1,
    },
    { labelId: 'Policies_List.table.status', xs: 1 },
    { labelId: 'Policies_List.table.brokerage', xs: 1.5 },
    { labelId: 'Policies_List.table.assignedTo', xs: 1.5 },
    { labelId: 'Policies_List.table.type', xs: 1 },
];

export const LIST_FIELDS = [
    {
        code: 'product',
        type: 'dropdown',
        label: 'Policies_List.table.product',
        optionsFrom: 'products',
        allLabel: 'Policies_List.search.allProducts',
    },
    {
        code: 'status',
        type: 'dropdown',
        label: 'Policies_List.table.status',
        options: STATUSES,
        allLabel: 'Policies_List.search.status.all',
    },
    {
        code: 'policyTransactionType',
        type: 'dropdown',
        label: 'Policies_List.table.type',
        options: TRANSACTION_TYPES,
        allLabel: 'Policies_List.search.transactionType.all',
    },
    {
        code: 'brokerCompanyReferenceGuid',
        type: 'dropdown',
        label: 'Policies_List.table.brokerage',
        reference: 'ActiveBrokerCompanies',
        allLabel: 'Policies_List.search.allBrokerages',
        visibleFor: ['administrator'],
        newRow: true,
    },
    {
        code: 'brokerReferenceGuid',
        type: 'dropdown',
        label: 'Policies_List.table.assignedTo',
        reference: 'ActiveBrokers',
        allLabel: 'Policies_List.search.allBrokers',
    },
    { code: 'clientFirstName', type: 'input', label: 'Policies_List.search.fname', newRow: true },
    { code: 'clientLastName', type: 'input', label: 'Policies_List.search.lname' },
    { code: 'clientPhoneFullNumber', type: 'input', label: 'Policies_List.search.insuredPhone' },
    { code: 'clientEmail', type: 'input', label: 'Policies_List.search.insuredEmail' },
    { code: 'referenceNumber', type: 'input', label: 'Policies_List.search.referenceNumber' },
    { code: 'policyNumber', type: 'input', label: 'Policies_List.search.policyNumber' },
];
